import { useQuery } from "@tanstack/react-query"
import { useState } from "react"
import { waitForCelerySuccess } from "../utils"


export function startCeleryTask(queryKey: string, queryFn: () => Promise<any>) {
  const [taskSuccess, setTaskSuccess] = useState<boolean | null>(null)
  const [isTaskLoading, setIsTaskLoading] = useState(false)

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: [queryKey],
    queryFn,
    enabled: false,
  })

  async function taskStatus() {
    setTaskSuccess(null)
    setIsTaskLoading(true)

    const result = await refetch()
    const taskId = result.data?.["task-id"]

    if (taskId) {
      const status = await waitForCelerySuccess(taskId, 800)
      setTaskSuccess(status)
    }
    setIsTaskLoading(false)
  }

  const loading = isLoading || isTaskLoading

  return {
    data,
    error,
    taskSuccess,
    taskStatus,
    loading,
  }
}
